import React from 'react';
import { HardHat } from 'lucide-react';
import ferramentasEpisService from 'features/estoque/services/ferramentasEpisService';
import BackupInfra from './BackupInfra';

const FerramentasEpis = () => (
  <BackupInfra
    service={ferramentasEpisService}
    icone={HardHat}
    titulo="Ferramentas e EPIs"
    descricao="Saldo atual das ferramentas e EPIs da lista da empresa, por produto e almoxarifado."
    vazioTitulo="Nenhuma ferramenta ou EPI com saldo"
    vazioTexto="Nenhum produto da lista tem saldo nos almoxarifados da empresa."
  />
);

export default FerramentasEpis;
